import { DatabaseOutlined } from "@ant-design/icons";
import { Permission, Resource } from "components/CurrentUser/constants";
import { Redirect } from "react-router";
import { IRouteConfig } from "services/typings";
import { lazy } from "utils/route";
import React from "react";

const routes: IRouteConfig[] = [
  {
    path: "/base-commission",
    name: "base_commission.title",
    icon: DatabaseOutlined,
    component: lazy(() => import("./BaseCommissionContainer")),
    exact: true,
    permissions: [
      [Resource.COMMISSION, Permission.VIEW],
      [Resource.COMMISSION, Permission.FULL_VIEW],
    ],
    placeholderConfig: {
      filter: true,
    },
  },
  {
    path: "/base-commission/create",
    name: "base_commission.title",
    icon: DatabaseOutlined,
    component: lazy(() => import("./pages/CreateBaseCommission")),
    exact: true,
    hideInMenu: true,
    permissions: [
      [Resource.COMMISSION, Permission.CREATE],
      [Resource.COMMISSION, Permission.FULL_CREATE],
    ],
  },
  {
    path: "/base-commission/:id",
    hideInMenu: true,
    exact: true,
    component: (props: any) => {
      return <Redirect to={`${props.location.pathname}/setting`} />;
    },
    permissions: [
      [Resource.COMMISSION, Permission.VIEW],
      [Resource.COMMISSION, Permission.FULL_VIEW],
    ],
  },
  {
    path: "/base-commission/:id/edit",
    name: "base_commission.title",
    hideInMenu: true,
    exact: true,
    component: lazy(() => import("./pages/CreateBaseCommission")),
    permissions: [
      [Resource.COMMISSION, Permission.UPDATE],
      [Resource.COMMISSION, Permission.FULL_UPDATE],
    ],
  },
  {
    path: "/base-commission/:id/:tab",
    name: "base_commission.title",
    hideInMenu: true,
    exact: true,
    component: lazy(() => import("./pages/DetailBaseCommission")),
    permissions: [
      [Resource.COMMISSION, Permission.VIEW],
      [Resource.COMMISSION, Permission.FULL_VIEW],
    ],
  },
];

export default routes;
